// Shared Recently Viewed utilities — used across Men, Women, and ProductDetail pages

const STORAGE_KEY = 'recentlyViewed'; // shared across all pages

export const getRecentlyViewed = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const seen = new Set();
    return raw.filter((entry) => {
      const id =
        typeof entry === 'object' && entry != null
          ? (entry._id || entry.id || '').toString().trim()
          : String(entry).trim();
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  } catch {
    return [];
  }
};

export const saveRecentlyViewed = (productId) => {
  try {
    const normalizedId =
      typeof productId === 'object' && productId != null
        ? (productId._id || productId.id || productId).toString().trim()
        : String(productId).trim();
    if (!normalizedId) return;
    const recent = getRecentlyViewed();
    const updated = [
      normalizedId,
      ...recent.filter((entry) => {
        const id =
          typeof entry === 'object' && entry != null
            ? (entry._id || entry.id || '').toString().trim()
            : String(entry).trim();
        return id !== normalizedId;
      }),
    ].slice(0, 10);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // Ignore storage errors
  }
};
